<template lang="pug">
div
  y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" :fullscreen="$vuetify.breakpoint.mobile" persistent fluid scrollable content-class="round-2xl")
    v-card
      v-card-title.pa-4
        div(style="width: 28px;")
        v-spacer
        .text-md.font-semibold Search
        v-spacer
        v-btn(icon @click="closeDialog" small color="primary")
          v-icon mdi-close
      v-card-text.px-0
        div.px-4
          v-text-field.text-sm.mt-2.round-xl(v-model="searchProducts" placeholder="Search inventory" @input="queryChanged" outlined dense height="40" hide-details clearable autofocus)
            template(#append)
              v-icon $yzi-search-sm

        template(v-if="!searchProducts")
          div.text-sm.neutral500--text.text-center.mt-16.px-4 Search result will show up here
        
        template(v-else)
          div.text-xs.neutral500--text.mt-6.px-4 RESULTS

          div.d-flex.justify-center.mt-16(v-if="isFetchingProducts")
            v-progress-circular(:width="2" :size="30" color="primary" indeterminate)
          
          template(v-else)
            template(v-for="product in products")
              div.pa-4(:key="product.id")
                v-row(no-gutters)
                  v-col.pr-1(cols="6" style="word-break: break-word;")
                    .text-sm.font-medium.neutral700--text {{ product.name }}
                  v-col.pl-1(cols="6" align="right" style="word-break: break-word;")
                    .text-sm.neutral700--text(v-if="getStockUnit(product)") {{ getStockUnit(product) }}
                    .text-sm.font-medium.success500--text(v-if="product.inventory_qty") Current count: {{ product.inventory_qty }}
                    .text-sm.font-medium.info500--text(v-if="checkActualCount(product)") Actual count: {{ checkActualCount(product) }}
                template(v-if="checkStockDiff(product) === null")
                  v-row.mt-2(no-gutters)
                    v-col.pr-1(cols="6")
                      y-button(label="New count" outlined size="sm" block @click="openNewCount(product)")
                    v-col.pl-1(cols="6")
                      y-button(label="Matched" outlined size="sm" block @click="matchingCount(product)")
                template(v-else)
                  v-row.mt-2(no-gutters)
                    v-col.pr-1(cols="6")
                      y-button(label="Remove" color="neutral300" text-color="danger500" size="sm" block @click="openRemoveCount(product)")
                    v-col.pl-1(cols="6")
                      y-button(label="Edit" outlined size="sm" block @click="openNewCount(product)")
              v-divider

            template(v-if="!products.length")
              div.text-sm.neutral500--text.text-center.mt-16.px-4 No item found

  .dialogs
    new-count-bottom-sheet(v-if="openNewCountSheet" :open.sync="openNewCountSheet" :product="selectedProduct" :stocktake-id="stocktakeId" :prefillCount="checkActualCount(selectedProduct) || selectedProduct.inventory_qty" :changed-products.sync="compChangedProduct" @closed="handleClosed")
    remove-count-dialog(v-if="openRemoveCountDialog" :open.sync="openRemoveCountDialog" :product="selectedProduct" :stocktake-id="stocktakeId" :changed-products.sync="compChangedProduct" @closed="handleClosed")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NewCountBottomSheet from '@/components/clinic/inventory/stocktake/NewCountBottomSheet.vue'
import RemoveCountDialog from '@/components/clinic/inventory/stocktake/RemoveCountDialog.vue'
import { debounce } from '@/utils'

export default {
  components: { NewCountBottomSheet, RemoveCountDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stocktakeId: {
      required: true
    },
    changedProducts: {
      type: Array,
      default: (() => [])
    },
  },
  data () {
    return {
      isLoading: false,
      isFetchingProducts: false,
      openNewCountSheet: false,
      openRemoveCountDialog: false,
      searchProducts: null,
      selectedProduct: null,
      newCount: 0,
      products: [],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0|| `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    compChangedProduct: {
      get () {
        return this.changedProducts 
      },
      set (newValue) {
        this.$emit('update:changedProducts', newValue)
      }
    }
  },
  mounted () {
  },
  methods: {
    getStockUnit (item) {
      if (item.uom_conversion_enabled && item.uom_conversions && item.uom_conversions.length) {
        return item.uom_conversions[item.uom_conversions.length - 1].convert_to || ''
      }
      return item.uom || ''
    },
    ...mapActions(['showMessage']),
    fetchProducts () {
      this.isFetchingProducts = true
      let params = {
        status: 'published',
        page_size: -1,
        fields: 'id,name,uom,inventory_qty,location'
      }
      if (this.searchProducts) {
        params.search = this.searchProducts
      } else {
        return
      }
      this.$axios.get(`/clinics/${this.company.slug}/inventories`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.products = resp.data.results
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingProducts = false
        })
    },
    queryChanged: debounce(function () {
      this.products = []
      this.fetchProducts()
    }, 750),
    checkActualCount (product) {
      let count = null
      let diff = this.checkStockDiff(product)
      if (diff !== null) {
        count = product.inventory_qty + diff
      }
      return count
    },
    checkStockDiff (product) {
      let quantity = null
      let findProduct = this.compChangedProduct.find(f => f.id === product.id)
      if (findProduct){
        quantity = findProduct.change
      }
      return quantity
    },
    openNewCount (product) {
      this.selectedProduct = product
      this.openNewCountSheet = true
    },
    openRemoveCount (product) {
      this.selectedProduct = product
      this.openRemoveCountDialog = true
    },
    matchingCount (item) {
      this.isLoading = true
      let products = [...this.compChangedProduct]
      products = products.filter(f => f.id !== item.id)
      products.push({ id: item.id, change: 0 })
      this.$axios.patch(`/clinics/${this.company.slug}/stock_takes/${this.stocktakeId}`, { products: products })
        .then(() => {
          this.compChangedProduct = [...products]
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
    handleClosed () {
      this.selectedProduct = null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
  .left-count-btn {
    border-radius: 10px 0 0 10px;
    border-color: var(--v-neutral400);
    border-right: 0px;
  }
  .right-count-btn {
    border-radius: 0 10px 10px 0;
    border-color: var(--v-neutral400);
    border-left: 0px;
  }
}
</style>